import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const { t, i18n } = useTranslation('');
  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (cookiesAccepted === null) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
<div className='info-cookies' style={{position: 'fixed', right: 0, bottom: '40px',left: '40px',border: '20px',
    width: '440px',
     backgroundColor: '#f4f4f4',
      boxShadow: '0 -1px 10px 0 #acabab4d',
      padding: '20px',
      zIndex: 1000, }}>
    <div className='cky-notice'>
     <h3 className='cky-title'>🍪 {t('footer.usaCokkies')}</h3>
      <div className='text-cookie-block'>
                    <p className='description-cookie'> {t('footer.msgCookies')}<a href='/politica-de-privacidade/'> {t('footer.poliPri')}</a></p>
                    </div>
        <div className='cky-notice-btn-wrapper' style={{ marginTop: '20px' }}>
        <button onClick={handleReject} style={{ marginRight: '10px' }} className='rejeitar-todos'>{t('footer.rejectCookies')} </button>
        <button onClick={handleAccept} className='aceitar-todos'>{t('footer.aceptCookies')}</button>
        </div>
     </div>
 </div>
  );
}

export default CookieBanner;